// extracted by mini-css-extract-plugin
export var legendIndicator = "_c1-1";
export var legendRight = "_c1-0";